module.exports = __webpack_public_path__ + "static/media/organisation-cream.694d5804.svg";